import HelpIcon from "@/components/ui/icon/help";
import { TableHead, TableHeader, TableRow } from "@/components/ui/table/table";

import { SearchResultTableToolTip } from "./tool-tip";

export const SearchResultTableTHead = () => (
	<TableHeader className="relative bg-bg-layer-400">
		<TableRow className="hover:bg-transparent">
			<TableHead justifyStyle="center" className="sticky left-0 w-32 bg-bg-layer-400 font-semibold">
				予約番号
			</TableHead>

			<TableHead justifyStyle="center" className=" bg-bg-layer-400 font-semibold tablet:sticky tablet:left-32">
				<div className="flex items-center justify-center gap-1">
					予約タイプ
					<SearchResultTableToolTip
						label={<HelpIcon className="size-[18px]" />}
						tooltipText="
						同じメールアドレスで再度ご予約いただいた予約に「リピータ」ラベルがつきます。<br />
						2025年10月10日以降の予約が対象となります。<br />
						詳細は<a href='https://www.notion.so/chillnn/286fffe15c5780ac8332f629c3cc3179' target='_blank' rel='noopener noreferrer' class='gap-x-0 break-all text-link-400'>こちら</a>。
						"
					/>
				</div>
			</TableHead>

			<TableHead justifyStyle="center" className="font-semibold">
				状態
			</TableHead>

			<TableHead justifyStyle="center" className="font-semibold">
				氏名
			</TableHead>

			<TableHead justifyStyle="center" className="font-semibold">
				チェックイン
			</TableHead>

			<TableHead justifyStyle="center" className="font-semibold">
				チェックアウト
			</TableHead>

			<TableHead justifyStyle="center" className="font-semibold">
				予約日
			</TableHead>

			<TableHead justifyStyle="center" className="font-semibold">
				合計料金（税込）
			</TableHead>

			<TableHead justifyStyle="center" className="font-semibold">
				決済方法
			</TableHead>

			<TableHead justifyStyle="center" className="font-semibold">
				人数
			</TableHead>

			<TableHead justifyStyle="center" className="font-semibold">
				部屋
			</TableHead>

			<TableHead justifyStyle="center" className="font-semibold">
				プラン
			</TableHead>

			<TableHead justifyStyle="center" className="font-semibold">
				オプション
			</TableHead>

			<TableHead justifyStyle="center" className="font-semibold">
				ディスカウント
			</TableHead>

			<TableHead justifyStyle="center" className="font-semibold">
				電話番号
			</TableHead>

			<TableHead justifyStyle="center" className="font-semibold">
				メールアドレス
			</TableHead>

			<TableHead justifyStyle="center" className="font-semibold">
				住所
			</TableHead>

			<TableHead justifyStyle="center" className="font-semibold">
				メルマガ配信希望
			</TableHead>
		</TableRow>
	</TableHeader>
);
